import { string, number, object } from '@gogame/schemas';

import {
  NAME,
  OWNER,
  PARTNER_COMPANY,
  AFFILIATES,
  INTEGRATED_PARTNER,
  INTEGRATION_START_DATE,
} from './constants';

export const ApiIntegrationFormValidationSchema = object({
  [NAME]: string().required('Name is required'),
  [OWNER]: number().required('Owner is required'),
  [PARTNER_COMPANY]: number().required('Partner company is required'),
  [AFFILIATES]: number().required('Affiliates is required'),
  [INTEGRATED_PARTNER]: number().required('Integrated partner is required'),
  [INTEGRATION_START_DATE]: string().required(
    'Integrated start date is required'
  ),
});
